import { ArpeggiSupportedChain } from '@arpeggi/shared'
import { useState } from 'react'
import { useAuth } from '../../../__legacy__/hooks/useAuth'
import { isCollectionHolder } from '../../api/functions'
import { useAsyncEffect } from '../../react-utils'

export const useIsEditionHolder = (collectionAddress: string, chain: ArpeggiSupportedChain) => {
  const { currentWalletAddress: userWalletAddress } = useAuth()
  const [isHolder, setIsHolder] = useState<boolean>(false)

  const status = useAsyncEffect(async () => {
    const resp = await isCollectionHolder({ userWalletAddress, collectionAddress, chain })
    setIsHolder(resp)
  }, [userWalletAddress, collectionAddress, chain])

  return { isHolder, status }
}
